import { isValidNumber } from "./isValidNumber";

export const getAltitudeInFeet = (value?: unknown, fallback = "N/A") => {
  const formatter = new Intl.NumberFormat("en-GB", {
    style: "unit",
    unit: "foot",
    unitDisplay: "short",
    maximumFractionDigits: 0,
  });

  if (!isValidNumber(value)) return fallback;
  return formatter.format(value);
};
